import React, { useCallback, useEffect, useMemo } from 'react';
import CustomSelect from '../../lib/form/Select/CustomSelect';
import { useGlobalContext } from '../../../context/GlobalContext';
import styles from './QuestionFiltersMobile.module.scss';
import { SET_FILTERS } from '../../../actions/types';
import { sortByKey } from '../../../utils/utils';
import { getDrugsListAction } from '../../../actions/questionsActions';
import { types } from '../Filters/Filters';

export default function QuestionsFiltersMobile({ hideAssignTo }) {
  const [context, dispatch] = useGlobalContext();

  const { filters, lists } = context.questions;

  const getDrugs = useCallback(() => {
    getDrugsListAction(dispatch);
  }, [dispatch]);

  const tagsOptions = useMemo(() => {
    return lists?.tags?.filter(opt => opt !== null)?.sort().map(opt => ({ value: opt, label: opt })) || [];
  }, [lists?.tags]);

  const drugsOptions = useMemo(() => {
    return lists?.drugs ? sortByKey(lists?.drugs, 'name')?.map((d) => ({ value: d._id, label: d.name })) : []
  }, [lists?.drugs]);


  const centersOptions = useMemo(() => {
    return lists?.centers?.map((c) => ({ value: c._id, label: `${c.name} - ${c.location.city}` })) || []
  }, [lists?.centers]);

  const assignToOptions = useMemo(() => {
    return lists?.users?.map((d) => ({ value: d._id, label: `${d.profile.firstName} ${d.profile.lastName}` }))
  }, [lists?.users])

  function setFilters(key, value) {
    dispatch({
      type: SET_FILTERS,
      payload: {
        ...filters,
        page: 1,
        [key]: value
      }
    });
  }

  useEffect(() => {
    getDrugs();
    // eslint-disable-next-line 
  }, []);

  return (
    <div className={styles.filters}>
      <div className={styles.filter}>
        <label>Tags</label>
        <CustomSelect
          isMulti
          value={tagsOptions?.filter((t) => filters.tags.find((s) => s === t.value)) || []}
          handleChange={(val) => setFilters('tags', val.map((v) => v.value))}
          options={tagsOptions}
        />
      </div>
      <div className={styles.filter}>
        <label>Produits</label>
        <CustomSelect
          isMulti
          value={drugsOptions?.filter((t) => filters.drugs.find((s) => s === t.value)) || []}
          handleChange={(val) => setFilters('drugs', val.map((v) => v.value))}
          options={drugsOptions}
        />
      </div>
      <div className={styles.filter}>
        <label>Centres</label>
        <CustomSelect
          isMulti
          value={centersOptions?.filter((t) => filters.centers.find((s) => s === t.value)) || []}
          handleChange={(val) => setFilters('centers', val.map((v) => v.value))}
          options={centersOptions}
        />
      </div>
      <div className={styles.filter}>
        <label>Types</label>
        <CustomSelect
          isMulti
          value={types?.filter((t) => filters.types.find((s) => s === t.value)) || []}
          handleChange={(val) => setFilters('types', val.map((v) => v.value))}
          options={types}
        />
      </div>
      {!hideAssignTo &&
        <div className={styles.filter}>
          <label>Attribué à</label>
          <CustomSelect
            isMulti
            value={assignToOptions?.filter((t) => filters?.assignTo?.find((s) => s === t.value)) || []}
            handleChange={(val) => setFilters('assignTo', val.map((v) => v.value))}
            options={assignToOptions}
          />
        </div>
      }
    </div>
  )
}
